import { getField, updateField } from 'vuex-map-fields'
import getGpToCostReportFiltersModel from './models/gpToCostReportFilters'

const gpToCostReportFilters = {
  namespaced: true,
  state: {
    ...getGpToCostReportFiltersModel()
  },
  getters: {
    getField,
    getSearchObject: (state) => {
      return state
    },
    reportFiltersList: (state) => {
      return [
        { key: 'Year', value: state.year }
      ]
    }
  },
  mutations: {
    updateField,
    clearFilters: (state) => {
      state.year = new Date().getFullYear()
      state.userId = null
    }
  },
  actions: {
    clearFilters: ({ commit }) => {
      return commit('clearFilters')
    }
  }
}

export default gpToCostReportFilters
